module.exports = __webpack_public_path__ + "img/SI.47674892.png";